module.exports = __webpack_public_path__ + "media/images/eq5d_logo-211b36f20d79c12a1d8d0495523f1327.png";